<script>
    import { _ } from 'svelte-i18n';
    export let params = {};
    import axios from 'axios';
    import { request,  getUsers, getRoles, getPermissions } from '../functions/http-helpers.js'
    import { url } from '../stores/url.js';
    import { user } from '../stores/user.js';
    import { link, push } from 'svelte-spa-router';



    let bv_firstname = '';
    let bv_lastname = '';
    let bv_email = '';
    let bv_email_confirm = '';
    let bv_password = '';
    let bv_password_confirm = '';

    function setLogin(data) {
        push('/');
        $user = data;
        /*
        getUsers();
        getRoles();
        getPermissions();
        */
    }



    /* POST */
    async function register() {
        const [ data, error ] = await request(`${$url}/auth/register`, {
            firstname: bv_firstname,
            lastname: bv_lastname,
            email: bv_email,
            email_confirm: bv_email_confirm,
            password: bv_password,
            password_confirm: bv_password_confirm,
        });
        if(!error) {
            setLogin(data);
        }
    }

 
    async function login() { 
        const [ data, error ] = await request(`${$url}/auth/login`, {
            email: bv_email,
            password: bv_password,
            password_confirm: bv_password,
        });
        if(!error) {
            setLogin(data);
        }
        
        /*
        console.log(validateAxiosResponse)
		if(!bv_email) {
			warningNotification('Keine E-Mail Adresse angegeben!');
		} else if(!bv_password) {
			warningNotification('Kein Passwort angegeben!');
		} else {
			const response = await axios.post(`${$url}/auth/login`, {
				email: bv_email,
				password: bv_password,
				password_confirm: bv_password,
			});
			if(validateAxiosResponse(response)) {
                push('/');
				$user = response.data;
				// todos = [...todos, response.data];
			}
		}
        */
	}
</script>


<div class="card uk-position-center" style="max-width: 90% !important">
    <h1 class="color-primary uk-text-bold">{params.auth_type == 'login' ? $_('login') :  $_('register')}</h1>

    {#if params.auth_type == 'registrieren'}
        <div uk-grid>
            <div class="uk-width-1-2@m uk-margin-top">
                <label>{$_('firstname')}: <span class="uk-text-danger">*</span></label>
                <input type="text" class="uk-input" bind:value={bv_firstname} />
            </div>
            <div class="uk-width-1-2@m uk-margin-top">
                <label>{$_('lastname')}: <span class="uk-text-danger">*</span></label>
                <input type="text" class="uk-input" bind:value={bv_lastname} />
            </div>
            <div class="uk-width-1-2@m uk-margin-top">
                <label>{$_('email')}: <span class="uk-text-danger">*</span></label>
                <input type="email" class="uk-input" bind:value={bv_email} />
            </div>
            <div class="uk-width-1-2@m uk-margin-top">
                <label>{$_('email')} {$_('confirm')}: <span class="uk-text-danger">*</span></label>
                <input type="email" class="uk-input" bind:value={bv_email_confirm} />
            </div>
            <div class="uk-width-1-2@m uk-margin-top">
                <label>{$_('password')}: <span class="uk-text-danger">*</span></label>
                <input type="password" class="uk-input" bind:value={bv_password} />
            </div>
            <div class="uk-width-1-2@m uk-margin-top">
                <label>{$_('password')} {$_('confirm')}: <span class="uk-text-danger">*</span></label>
                <input type="password" class="uk-input" bind:value={bv_password_confirm} />
            </div>
            <div class="uk-width-1-1">
                <a class="btn-default uk-width-1-1 uk-width-auto@m" href="/auth/login" use:link>{$_('to')} {$_('login')}</a>
                &nbsp;<!-- margin top < @m -->
                <button class="btn-primary uk-float-right uk-width-1-1 uk-width-auto@m" on:click={() => register()}>{$_('register')}</button>
            </div>
        </div>
    {:else}
        <div uk-grid>
            <div class="uk-width-1-1 uk-margin-top">
                <label>{$_('user-nr')}: <span class="uk-text-danger">*</span></label>
                <input type="email" class="uk-input" bind:value={bv_email} />
            </div>
            <div class="uk-width-1-1 uk-margin-top">
                <label>{$_('password')}: <span class="uk-text-danger">*</span></label>
                <input type="password" class="uk-input" bind:value={bv_password} on:keyup={e => e.key == 'Enter' && login()} />
            </div>
            <div class="uk-width-1-1">
                <!--
                <a class="btn-default uk-width-1-1 uk-width-auto@m" href="/auth/registrieren" use:link>{$_('to')} {$_('register')}</a>
                &nbsp; margin top < @m  
                -->
                <button class="btn-primary uk-float-right uk-width-1-1 uk-width-auto@m" on:click={() => login()}>{$_('login')}</button>
            </div>
        </div>
    {/if}
</div>